import { SET_FROM_TRAINING_GUIDANCE, CLEAR_FROM_TRAINING_GUIDANCE } from 'actions/ActionTypes';

const INITIAL_STATE = {
    fromTrainingGuidance: false
};

const setFromTrainingGuidance = () => {
    return {
        fromTrainingGuidance: true
    };
};

const clearFromTrainingGuidance = () => {
    return {
        fromTrainingGuidance: false
    };
};

export const getFromTrainingGuidance = (state) => state?.trainingGuidance?.fromTrainingGuidance;

const handlers = {
    [SET_FROM_TRAINING_GUIDANCE]: setFromTrainingGuidance,
    [CLEAR_FROM_TRAINING_GUIDANCE]: clearFromTrainingGuidance
};

// ======= Default Action =======
export default function trainingGuidance(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
